export default function ({ width = "0.9rem", stroke }) {
  return (
    <svg
      width={width}
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9999 14.1667V5.83334M5.99988 14.1667V0.833344M0.999878 14.1667V9.16668"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
